import { Link } from "react-router-dom";
import { Star, MapPin, ShieldCheck } from "lucide-react";
import { fileUrl } from "@/lib/api";
import { FavoriteButton } from "@/components/FavoriteButton";

export function KitchenCard({ k }) {
  const cover = k.photos?.[0] ? fileUrl(k.photos[0]) : "https://images.unsplash.com/photo-1782750161991-23529c9462bb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwzfHxjb21tZXJjaWFsJTIwa2l0Y2hlbiUyMHN0YWlubGVzcyUyMHN0ZWVsfGVufDB8fHx8MTc4NzM4OTQyMXww&ixlib=rb-4.1.0&q=85";
  return (
    <Link
      data-testid={`kitchen-card-${k.id}`}
      to={`/kitchen/${k.id}`}
      className="k-card block"
    >
      <div className="aspect-[4/3] overflow-hidden bg-neutral-900 relative">
        <img src={cover} alt={k.name} className="w-full h-full object-cover" loading="lazy" />
        {k.host_verified && (
          <div
            data-testid={`verified-host-badge-${k.id}`}
            className="absolute top-3 left-3 flex items-center gap-1 bg-[#FF3B30] text-white px-2 py-1 text-[10px] uppercase tracking-widest font-medium"
            title="This host has cleared at least one paid booking"
          >
            <ShieldCheck size={12} strokeWidth={2.5} /> Verified host
          </div>
        )}
        <FavoriteButton kitchenId={k.id} />
      </div>
      <div className="p-5">
        <div className="flex items-baseline justify-between">
          <h3 className="font-display font-bold text-xl truncate pr-2">{k.name}</h3>
          <div className="text-right">
            <div className="font-mono text-lg font-semibold">${k.hourly_rate}</div>
            <div className="tick-label">per hr</div>
          </div>
        </div>
        <div className="mt-2 flex items-center gap-1 text-neutral-400 text-sm">
          <MapPin size={13} /> <span>{k.city}{k.state ? `, ${k.state}` : ""}</span>
        </div>
        {k.review_count > 0 && (
          <div className="mt-3 flex items-center gap-1 text-sm">
            <Star size={14} className="fill-[#FF3B30] text-[#FF3B30]" />
            <span className="font-mono">{k.rating.toFixed(1)}</span>
            <span className="text-neutral-500">({k.review_count})</span>
          </div>
        )}
        <div className="mt-3">
          <span className="tick-label">{k.booking_mode === "instant" ? "Instant book" : "Approval required"}</span>
        </div>
      </div>
    </Link>
  );
}
